import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";
import {toast,Toaster} from "react-hot-toast";

export default function CameraFeedUpload() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [videoFiles, setVideoFiles] = useState([]);

  const navigate = useNavigate();

  /* 🔴 FETCH USERS API HERE LATER */
  useEffect(() => {
    setUsers([
      {
        id: "1",
        name: "Admin User",
        email: "admin@example.com",
        uuid: "da8syf0s98fy9-asdfyas9f-as9yfdsadys9fdy",
      },
      {
        id: "2",
        name: "John Doe",
        email: "john@example.com",
        uuid: "as8df7asf8-asdf8as7df",
      },
    ]);
  }, []);

  const currentUser = users.find((u) => u.id === selectedUser);

  const handleFileChange = (e) => {
    setVideoFiles([...e.target.files]);
  };

  const handleUpload = () => {
    if (!currentUser || videoFiles.length === 0) {
      toast.error("Please select user and video files");
      return;
    }

    // 🔴 API CALL HERE LATER

    toast.success("Camera feed uploaded successfully ✅");

    // optional reset
    setSelectedUser("");
    setVideoFiles([]);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />
      <Toaster position="top-right" />

      {/* Main */}
      <div className="flex-1 bg-white rounded-l-2xl p-4 sm:p-6">
        <h1 className="text-lg font-semibold text-green-700 mb-6 text-center sm:text-center">
          Camera Feed Upload
        </h1>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            {/* Select User */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-start">
              <label className="sm:col-span-4 text-sm font-medium text-gray-700 text-center sm:text-right sm:pt-2">
                Select User
              </label>

              <div className="sm:col-span-8">
                <select
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                  className="w-full border rounded-md px-4 py-2 text-sm"
                >
                  <option value="">Select User</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name} ({u.email})
                    </option>
                  ))}
                </select>

                {currentUser && (
                  <p className="text-xs text-gray-500 mt-1 text-center sm:text-left">
                    userUuid: {currentUser.uuid}
                  </p>
                )}
              </div>
            </div>

            {/* Video Upload */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-center">
              <label className="sm:col-span-4 text-sm font-medium text-gray-700 text-center sm:text-right">
                Select Video Files
              </label>

              <div className="sm:col-span-8">
                <input
                  type="file"
                  multiple
                  accept="video/*"
                  onChange={handleFileChange}
                  className="w-full border rounded-md px-4 py-2 text-sm"
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-center sm:justify-end gap-4 pt-6">
              <button 
                onClick={() => navigate("/all-users")}
              className="px-6 py-2 border rounded-md text-sm">
                Cancel
              </button>

              <button
                onClick={handleUpload}
                className="px-6 py-2 bg-green-600 text-white rounded-md text-sm"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
